import {BaseFormModel} from './base-form-model';
import {WifiPrinter} from './wifi-printer';
import {Order} from './order';

export class PrintJob extends BaseFormModel<PrintJob> {
    key: string;
    wifiPrinter: WifiPrinter;
    order: Order;
    printType: string;
    retry: number;
    timeout: any;
    retrying: boolean;
}
